import React, { useMemo } from 'react';

import ProfileTimelineCard, { toSortTime } from './ProfileTimelineCard';

import { CARD_USER_EDUCATION } from '../../utils/constant/card';

function EducationCard({ data, onClickEdit }) {
  const items = useMemo(
    () =>
      [...(data || [])]
        .sort((a, b) => toSortTime(b?.eduInfo?.start) - toSortTime(a?.eduInfo?.start))
        .map((education, index) => ({
          key: education?._id || index,
          title: education?.eduInfo?.institute?.name,
          subtitle: education?.eduInfo?.degree?.name,
          start: education?.eduInfo?.start,
          end: education?.eduInfo?.end
        })),
    [data]
  );

  return (
    <ProfileTimelineCard
      title={CARD_USER_EDUCATION.EDUCATION}
      icon="bi-book"
      itemIcon="bi-book"
      items={items}
      emptyText="No education details available."
      onClickEdit={onClickEdit}
    />
  );
}

export default EducationCard;
